type FogLevel = 'map' | 'personas';

export interface UiContext {
	backgroundBlurred: boolean;
	fogLevel: FogLevel | null;
	personasVisible: boolean;
	personasEnabled: boolean;
	personasEnabledIndex: number | null;
	feedbackVisible: boolean;
	toolbarScoreVisible: boolean;
	toolbarConceptsVisible: boolean;
	toolbarConceptsEnabled: boolean;
	scoreVisible: boolean;
	toolbarTutorialVisible: boolean;
	personaName?: string;
	conceptName?: string;
}

// #region Initial context

const initialContext: UiContext = {
	backgroundBlurred: false,
	fogLevel: null,
	personasVisible: false,
	personasEnabled: false,
	personasEnabledIndex: null,
	feedbackVisible: false,
	toolbarScoreVisible: false,
	toolbarConceptsVisible: false,
	toolbarConceptsEnabled: false,
	scoreVisible: false,
	toolbarTutorialVisible: false
};

// #endregion

export default initialContext;
